/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "./utils";
import { Icon } from "@aws-amplify/ui-react";
export default function MyIcon(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    { overrides: { MyIcon: {} }, variantValues: { type: "warning" } },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M16.3636 2.46429L13.9091 2.46429L13.9091 1.64286C13.9091 1.20714 13.7367 0.789277 13.4298 0.481182C13.1229 0.173086 12.7067 3.64788e-16 12.2727 0L5.72727 0C5.29328 3.64788e-16 4.87707 0.173086 4.57019 0.481182C4.26331 0.789277 4.09091 1.20714 4.09091 1.64286L4.09091 2.46429L1.63636 2.46429C1.20237 2.46429 0.786157 2.63737 0.47928 2.94547C0.172402 3.25356 1.45338e-15 3.67143 0 4.10714L0 21.3571C7.26691e-16 21.7929 0.172402 22.2107 0.47928 22.5188C0.786157 22.8269 1.20237 23 1.63636 23L16.3636 23C16.7976 23 17.2138 22.8269 17.5207 22.5188C17.8276 22.2107 18 21.7929 18 21.3571L18 4.10714C18 3.67143 17.8276 3.25356 17.5207 2.94547C17.2138 2.63737 16.7976 2.46429 16.3636 2.46429ZM5.72727 1.64286L12.2727 1.64286L12.2727 4.92857L5.72727 4.92857L5.72727 1.64286ZM16.3636 21.3571L1.63636 21.3571L1.63636 4.10714L4.09091 4.10714L4.09091 6.57143L13.9091 6.57143L13.9091 4.10714L16.3636 4.10714L16.3636 21.3571Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 0%)" },
            },
            {
              d: "M4.16667 4.8L5.83333 4.8L5.83333 8L4.16667 8L4.16667 4.8ZM8.33333 3.2L10 3.2L10 8L8.33333 8L8.33333 3.2ZM0 0L1.66667 0L1.66667 8L0 8L0 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(29.17%, 45.83%)" },
            },
          ],
        },
      },
      variantValues: { type: "TrafficReport" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M0.5 1C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526787 0.759785 0 0.632608 0 0.5C0 0.367392 0.0526787 0.240215 0.146447 0.146447C0.240215 0.0526787 0.367392 0 0.5 0C0.632608 0 0.759785 0.0526787 0.853553 0.146447C0.947321 0.240215 1 0.367392 1 0.5C1 0.632608 0.947321 0.759785 0.853553 0.853553C0.759785 0.947321 0.632608 1 0.5 1Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(41.67%, 50%)" },
            },
            {
              d: "M2.00025 8.16667C2.11342 8.16667 2.22483 8.15733 2.33333 8.13867L2.33333 12.8333L0.875 12.8333C0.797645 12.8333 0.723459 12.8641 0.668761 12.9188C0.614062 12.9735 0.583333 13.0476 0.583333 13.125L0.583333 13.7083C0.583333 13.7857 0.614062 13.8599 0.668761 13.9146C0.723459 13.9693 0.797645 14 0.875 14L20.125 14C20.2024 14 20.2765 13.9693 20.3312 13.9146C20.3859 13.8599 20.4167 13.7857 20.4167 13.7083L20.4167 13.125C20.4167 13.0476 20.3859 12.9735 20.3312 12.9188C20.2765 12.8641 20.2024 12.8333 20.125 12.8333L18.6667 12.8333L18.6667 8.13867C18.7752 8.15733 18.8866 8.16667 18.9997 8.16667C20.1092 8.16667 21 7.26133 21 6.15475L21 4.76058C21.0001 4.5756 20.9679 4.39202 20.9049 4.21808L19.6332 0.71225C19.5578 0.503586 19.4199 0.323247 19.2383 0.195795C19.0566 0.0683433 18.8401 -2.55321e-05 18.6182 7.15257e-09L2.38117 7.15257e-09C2.15941 0.000257568 1.94312 0.068823 1.76172 0.196369C1.58032 0.323914 1.44261 0.504247 1.36733 0.712833L0.0956667 4.21808C0.0324828 4.39198 0.000108948 4.57556 0 4.76058L0 6.15475C-1.03621e-15 7.26133 0.89075 8.16667 2.00025 8.16667ZM1.19233 4.61592L2.44358 1.16667L18.5558 1.16667L19.8071 4.61592C19.8246 4.66258 19.8328 4.711 19.8328 4.76058L19.8328 6.15475C19.8341 6.37733 19.7471 6.59137 19.5908 6.74985C19.4346 6.90833 19.2217 6.9983 18.9992 7C18.5442 7 18.1662 6.62667 18.1662 6.15475C18.1662 6.00004 18.1047 5.85167 17.9953 5.74227C17.8859 5.63287 17.7375 5.57142 17.5828 5.57142C17.4281 5.57142 17.2798 5.63287 17.1704 5.74227C17.061 5.85167 16.9995 6.00004 16.9995 6.15475C17.0009 6.37733 16.9139 6.59137 16.7576 6.74985C16.6013 6.90833 16.3885 6.9983 16.1659 7C15.7109 7 15.3329 6.62667 15.3329 6.15533C15.3329 6.00062 15.2715 5.85225 15.1621 5.74285C15.0527 5.63346 14.9043 5.572 14.7496 5.572C14.5949 5.572 14.4465 5.63346 14.3371 5.74285C14.2277 5.85225 14.1662 6.00062 14.1662 6.15533C14.1662 6.62667 13.7882 7 13.3327 7C12.8771 7 12.4997 6.62667 12.4997 6.15475C12.4997 6.00004 12.4382 5.85167 12.3288 5.74227C12.2194 5.63287 12.071 5.57142 11.9163 5.57142C11.7616 5.57142 11.6133 5.63287 11.5039 5.74227C11.3945 5.85167 11.333 6.00004 11.333 6.15475C11.3346 6.37728 11.2477 6.59132 11.0915 6.74982C10.9353 6.90832 10.7225 6.9983 10.5 7C10.2775 6.9983 10.0648 6.90841 9.90852 6.75006C9.75225 6.5917 9.66517 6.37781 9.66642 6.15533C9.66642 6.00062 9.60496 5.85225 9.49556 5.74285C9.38617 5.63346 9.23779 5.572 9.08308 5.572C8.92837 5.572 8.78 5.63346 8.6706 5.74285C8.56121 5.85225 8.49975 6.00062 8.49975 6.15533C8.49975 6.62667 8.12233 7 7.66675 7C7.21117 7 6.83317 6.62667 6.83317 6.15475C6.83317 6.00004 6.77171 5.85167 6.66231 5.74227C6.55292 5.63287 6.40454 5.57142 6.24983 5.57142C6.09512 5.57142 5.94675 5.63287 5.83735 5.74227C5.72796 5.85167 5.6665 6.00004 5.6665 6.15475C5.6665 6.62608 5.28908 7 4.8335 7C4.37792 7 3.99992 6.62667 3.99992 6.15475C3.99992 6.00004 3.93846 5.85167 3.82906 5.74227C3.71967 5.63287 3.57129 5.57142 3.41658 5.57142C3.26187 5.57142 3.1135 5.63287 3.0041 5.74227C2.89471 5.85167 2.83325 6.00004 2.83325 6.15475C2.83325 6.62608 2.45583 7 2.00025 7C1.54408 7 1.16667 6.62667 1.16667 6.15475L1.16667 4.76058C1.16666 4.71123 1.17534 4.66226 1.19233 4.61592ZM17.5 7.6545C17.1345 7.98488 16.6592 8.16744 16.1665 8.16667C15.903 8.16699 15.642 8.11485 15.3989 8.0133C15.1557 7.91175 14.9352 7.76281 14.7502 7.57517C14.5651 7.76288 14.3445 7.91186 14.1012 8.01341C13.8579 8.11497 13.5969 8.16706 13.3333 8.16667C13.0697 8.16699 12.8088 8.11485 12.5656 8.0133C12.3225 7.91175 12.1019 7.76281 11.9169 7.57517C11.7318 7.76288 11.5112 7.91186 11.2679 8.01341C11.0247 8.11497 10.7636 8.16706 10.5 8.16667C10.2364 8.16706 9.97533 8.11497 9.73206 8.01341C9.48879 7.91186 9.26817 7.76288 9.08308 7.57517C8.89806 7.76281 8.67754 7.91175 8.43438 8.0133C8.19121 8.11485 7.93027 8.16699 7.66675 8.16667C7.112 8.16667 6.61092 7.93975 6.24983 7.57517C6.06481 7.76281 5.84429 7.91175 5.60113 8.0133C5.35796 8.11485 5.09702 8.16699 4.8335 8.16667C4.32017 8.16667 3.8535 7.97242 3.5 7.6545L3.5 12.8333L4.95833 12.8333C4.88098 12.8333 4.80679 12.8026 4.75209 12.7479C4.6974 12.6932 4.66667 12.619 4.66667 12.5417L4.66667 11.375C4.66667 11.2976 4.6974 11.2235 4.75209 11.1688C4.80679 11.1141 4.88098 11.0833 4.95833 11.0833L6.70833 11.0833C6.78569 11.0833 6.85987 11.1141 6.91457 11.1688C6.96927 11.2235 7 11.2976 7 11.375L7 11.6667L7.875 11.6667C7.95235 11.6667 8.02654 11.6974 8.08124 11.7521C8.13594 11.8068 8.16667 11.881 8.16667 11.9583L8.16667 12.5417C8.16667 12.619 8.13594 12.6932 8.08124 12.7479C8.02654 12.8026 7.95235 12.8333 7.875 12.8333L17.5 12.8333L17.5 7.6545ZM1.16667 15.75C1.16667 15.5953 1.22812 15.4469 1.33752 15.3375C1.44692 15.2281 1.59529 15.1667 1.75 15.1667L19.25 15.1667C19.4047 15.1667 19.5531 15.2281 19.6625 15.3375C19.7719 15.4469 19.8333 15.5953 19.8333 15.75L19.8333 20.4167C19.8333 20.5714 19.7719 20.7197 19.6625 20.8291C19.5531 20.9385 19.4047 21 19.25 21L1.75 21C1.59529 21 1.44692 20.9385 1.33752 20.8291C1.22812 20.7197 1.16667 20.5714 1.16667 20.4167L1.16667 15.75ZM2.33333 19.8333L2.33333 16.3333L18.6667 16.3333L18.6667 19.8333L2.33333 19.8333Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(4.17%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "Market" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M0 1.88406C0 0.843532 0.915541 0 2.04494 0L11.9551 0C13.0845 0 14 0.843538 14 1.88406L14 2.89855C14 3.3788 13.5774 3.76812 13.0562 3.76812C12.5349 3.76812 12.1124 3.3788 12.1124 2.89855L12.1124 1.88406C12.1124 1.80401 12.0419 1.73913 11.9551 1.73913L2.04494 1.73913C1.95807 1.73913 1.88764 1.80402 1.88764 1.88406L1.88764 18.1159C1.88764 18.196 1.95806 18.2609 2.04494 18.2609L11.9551 18.2609C12.0419 18.2609 12.1124 18.196 12.1124 18.1159L12.1124 17.1014C12.1124 16.6212 12.5349 16.2319 13.0562 16.2319C13.5774 16.2319 14 16.6212 14 17.1014L14 18.1159C14 19.1565 13.0845 20 11.9551 20L2.04494 20C0.91557 20 0 19.1565 0 18.1159L0 1.88406Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(12.5%, 8.33%)" },
            },
            {
              d: "M0 1C0 0.447715 0.39238 0 0.876404 0L12.1236 0C12.6076 0 13 0.447715 13 1C13 1.55228 12.6076 2 12.1236 2L0.876404 2C0.39238 2 0 1.55228 0 1Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(29.17%, 45.83%)" },
            },
            {
              d: "M0.225388 0.230473C0.525904 -0.0768244 1.01314 -0.0768244 1.31365 0.230473L5 4L1.31365 7.76953C1.01314 8.07682 0.525904 8.07682 0.225388 7.76953C-0.0751292 7.46223 -0.0751292 6.964 0.225388 6.6567L2.82346 4L0.225388 1.3433C-0.0751292 1.036 -0.0751292 0.537771 0.225388 0.230473Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(66.67%, 33.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "LogOut" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M8 0C6.93913 8.88178e-16 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 8.88178e-16 8 0ZM15 8C14.9389 7.99886 14.8793 8.01929 14.8318 8.05769C14.7842 8.09609 14.7517 8.15002 14.74 8.21L14.55 9.53C14.25 9.66 13.96 9.82 13.7 10L12.46 9.5C12.35 9.5 12.22 9.5 12.15 9.63L11.15 11.36C11.09 11.47 11.11 11.6 11.21 11.68L12.27 12.5C12.2301 12.8321 12.2301 13.1679 12.27 13.5L11.21 14.32C11.1651 14.3585 11.1346 14.4113 11.1237 14.4694C11.1128 14.5276 11.1221 14.5878 11.15 14.64L12.15 16.37C12.21 16.5 12.34 16.5 12.46 16.5L13.7 16C13.96 16.18 14.24 16.35 14.55 16.47L14.74 17.79C14.76 17.91 14.86 18 15 18L17 18C17.11 18 17.22 17.91 17.24 17.79L17.43 16.47C17.73 16.34 18 16.18 18.27 16L19.5 16.5C19.63 16.5 19.76 16.5 19.83 16.37L20.83 14.64C20.8579 14.5878 20.8672 14.5276 20.8563 14.4694C20.8454 14.4113 20.8149 14.3585 20.77 14.32L19.7 13.5C19.72 13.33 19.74 13.17 19.74 13C19.74 12.83 19.73 12.67 19.7 12.5L20.76 11.68C20.8049 11.6415 20.8354 11.5887 20.8463 11.5306C20.8572 11.4724 20.8479 11.4122 20.82 11.36L19.82 9.63C19.76 9.5 19.63 9.5 19.5 9.5L18.27 10C18 9.82 17.73 9.65 17.42 9.53L17.23 8.21C17.2237 8.15304 17.1969 8.10032 17.1546 8.06167C17.1122 8.02303 17.0573 8.00111 17 8L15 8ZM8 10C3.58 10 0 11.79 0 14L0 16L9.68 16C9.2337 15.0628 9.00142 14.038 9 13C9.00203 11.9953 9.22031 11.0028 9.64 10.09C9.11 10.03 8.56 10 8 10ZM16 11.5C16.83 11.5 17.5 12.17 17.5 13C17.5 13.83 16.83 14.5 16 14.5C15.16 14.5 14.5 13.83 14.5 13C14.5 12.17 15.17 11.5 16 11.5Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "Account" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 11.3132 19.7413 12.6136 19.2388 13.8268C18.7362 15.0401 17.9997 16.1425 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C2.00035 16.1425 1.26375 15.0401 0.761205 13.8268C0.258658 12.6136 0 11.3132 0 10C5.96046e-08 7.34784 1.05357 4.8043 2.92893 2.92893ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C3.84444 4.84185 3.41838 5.39961 3.07177 6L16.9282 6C16.5816 5.39961 16.1556 4.84185 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM17.746 8L2.25401 8C2.08671 8.64788 2 9.31947 2 10C2 10.6762 2.08573 11.3482 2.25403 12L17.746 12C17.9143 11.3482 18 10.6762 18 10C18 9.31947 17.9133 8.64788 17.746 8ZM16.9282 14L3.0718 14C3.42061 14.6042 3.84772 15.1614 4.34315 15.6569C5.08601 16.3997 5.96793 16.989 6.93853 17.391C7.90914 17.7931 8.94942 18 10 18C11.0506 18 12.0909 17.7931 13.0615 17.391C14.0321 16.989 14.914 16.3997 15.6569 15.6569C16.1523 15.1614 16.5794 14.6042 16.9282 14Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
            {
              d: "M4.0778 0.134096C3.61316 -0.134538 3.01574 0.011925 2.72943 0.470723C0.945673 3.32914 0 6.63082 0 10.0001C0 13.3695 0.945673 16.6711 2.72943 19.5295C3.01574 19.9883 3.61316 20.1348 4.0778 19.8662C4.54244 20.1348 5.13985 19.9883 5.42616 19.5295C7.20992 16.6711 8.15559 13.3695 8.15559 10.0001C8.15559 6.63082 7.20992 3.32914 5.42616 0.470723C5.13985 0.011925 4.54243 -0.134538 4.0778 0.134096ZM4.07779 17.8851C5.43784 15.4837 6.15559 12.7676 6.15559 10.0001C6.15559 7.23267 5.43784 4.51654 4.07779 2.11519C2.71775 4.51654 2 7.23267 2 10.0001C2 12.7676 2.71775 15.4837 4.07779 17.8851Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(33.01%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "AuthorizeRegion" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.05921 2C2.04351 2 2.02845 2.00624 2.01734 2.01734C2.00624 2.02845 2 2.04351 2 2.05921L2 19.0066C2 19.0223 2.00624 19.0373 2.01734 19.0484C2.02845 19.0596 2.0435 19.0658 2.05921 19.0658L20.0658 19.0658C20.0815 19.0658 20.0966 19.0596 20.1077 19.0484C20.1188 19.0373 20.125 19.0223 20.125 19.0066L20.125 5.23684C20.125 5.22114 20.1188 5.20608 20.1077 5.19497C20.0966 5.18387 20.0815 5.17763 20.0658 5.17763L11.0625 5.17763C10.7657 5.17763 10.4843 5.04581 10.2943 4.81782L7.9461 2L2.05921 2ZM0.603129 0.603129C0.989306 0.216952 1.51307 0 2.05921 0L8.41447 0C8.71125 0 8.9927 0.131823 9.1827 0.359816L11.5309 3.17763L20.0658 3.17763C20.6119 3.17763 21.1357 3.39458 21.5219 3.78076C21.9081 4.16694 22.125 4.69071 22.125 5.23684L22.125 19.0066C22.125 19.5527 21.9081 20.0765 21.5219 20.4627C21.1357 20.8488 20.6119 21.0658 20.0658 21.0658L2.05921 21.0658C1.51308 21.0658 0.989307 20.8488 0.603129 20.4627C0.216951 20.0765 0 19.5527 0 19.0066L0 2.05921C0 1.51307 0.216952 0.989306 0.603129 0.603129Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(4.17%, 4.17%)" },
            },
            {
              d: "M5.05937 0.292893C5.44989 -0.0976311 6.08306 -0.0976311 6.47358 0.292893L9.12161 2.94092C9.40761 3.22692 9.49316 3.65704 9.33838 4.03071C9.1836 4.40438 8.81897 4.64803 8.4145 4.64803L1.00003 4.64803C0.447744 4.64803 2.91966e-05 4.20031 2.91966e-05 3.64803C2.91966e-05 3.09574 0.447744 2.64803 1.00003 2.64803L6.00029 2.64803L5.05937 1.70711C4.66885 1.31658 4.66885 0.683417 5.05937 0.292893ZM0.0761497 6.44297C0.230931 6.0693 0.595567 5.82566 1.00003 5.82566L8.4145 5.82566C8.96679 5.82566 9.4145 6.27337 9.4145 6.82566C9.4145 7.37794 8.96679 7.82566 8.4145 7.82566L3.41424 7.82566L4.35516 8.76658C4.74569 9.1571 4.74569 9.79027 4.35516 10.1808C3.96464 10.5713 3.33147 10.5713 2.94095 10.1808L0.292922 7.53276C0.00692445 7.24677 -0.0786313 6.81665 0.0761497 6.44297Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: { transform: "translate(30.65%, 32.85%)" },
            },
          ],
        },
      },
      variantValues: { type: "ConversionReport" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M3 5h18a1 1 0 011 1v14a2 2 0 01-2 2H4a2 2 0 01-2-2V6a1 1 0 011-1h18V3H3v2z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              transform: "translate(0%, 0%)"
            },
            {
              d: "M7 10h2v6H7v-6zM11 8h2v8h-2V8zM15 12h2v4h-2v-4z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              transform: "translate(0%, 0%)"
            },
            {
              d: "M8 2h8v2H8V2z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              transform: "translate(0%, 0%)"
            }
          ],
        },
      },
      variantValues: { type: "CorporateAnalyticsReport" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M3.88889 5.71429C3.88889 6.55086 4.07333 7.34171 4.38778 8.05829L0 12.5714L0 14.2857C0 14.2857 0.995556 16 2.22222 16L4.44444 16L4.44444 13.7143L6.66667 13.7143L6.66667 11.4286L9.44444 11.4286C12.5133 11.4286 15 8.87086 15 5.71429C15 2.55771 12.5133 0 9.44444 0C6.37556 0 3.88889 2.55771 3.88889 5.71429ZM9.44444 8C9.15255 7.99993 8.86352 7.94071 8.59387 7.82575C8.32421 7.71078 8.07922 7.54231 7.87287 7.32996C7.66651 7.1176 7.50285 6.86552 7.39121 6.58811C7.27957 6.3107 7.22215 6.01338 7.22222 5.71314C7.2223 5.4129 7.27986 5.11562 7.39163 4.83826C7.50341 4.56091 7.6672 4.30891 7.87365 4.09666C8.08011 3.88441 8.32519 3.71607 8.59489 3.60124C8.8646 3.48642 9.15366 3.42735 9.44556 3.42743C10.0351 3.42758 10.6004 3.6686 11.0171 4.09747C11.4339 4.52634 11.6679 5.10793 11.6678 5.71429C11.6676 6.32065 11.4333 6.90211 11.0163 7.33077C10.5994 7.75942 10.034 8.00015 9.44444 8Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 16.67%)" },
            },
          ],
        },
      },
      variantValues: { type: "Key" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M13 8L8 8L8 13C8 13.55 7.55 14 7 14C6.45 14 6 13.55 6 13L6 8L1 8C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6L6 6L6 1C6 0.45 6.45 0 7 0C7.55 0 8 0.45 8 1L8 6L13 6C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 20.83%)" },
            },
          ],
        },
      },
      variantValues: { type: "Add" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M21 3L21 1.5L18.75 1.5L18.75 0L17.25 0L17.25 1.5L16.5 1.5C15.6727 1.5 15 2.1735 15 3L15 4.5C15 5.32725 15.6727 6 16.5 6L19.5 6L19.5 7.5L15 7.5L15 9L17.25 9L17.25 10.5L18.75 10.5L18.75 9L19.5 9C20.3272 9 21 8.32725 21 7.5L21 6C21 5.1735 20.3272 4.5 19.5 4.5L16.5 4.5L16.5 3L21 3ZM16.5 13.5L16.5 15L18.4395 15L15.75 17.6895L14.031 15.9697C13.8906 15.8293 13.7001 15.7502 13.5015 15.75L13.5 15.75C13.4016 15.75 13.3042 15.7694 13.2134 15.8071C13.1225 15.8448 13.04 15.9001 12.9705 15.9697L9 19.9395L10.0605 21L13.5007 17.5605L15.2197 19.2803C15.3604 19.4209 15.5511 19.4998 15.75 19.4998C15.9489 19.4998 16.1396 19.4209 16.2803 19.2803L19.5 16.0605L19.5 18L21 18L21 13.5L16.5 13.5ZM1.5 21L0 21L0 17.25C0 14.355 2.355 12 5.25 12L9.75 12C11.2417 12 12.6675 12.6375 13.6627 13.7498L12.5452 14.7502C12.1933 14.3572 11.7624 14.0428 11.2808 13.8273C10.7992 13.6119 10.2776 13.5004 9.75 13.5L5.25 13.5C3.18225 13.5 1.5 15.1823 1.5 17.25L1.5 21ZM7.5 10.5C8.89239 10.5 10.2277 9.94688 11.2123 8.96231C12.1969 7.97774 12.75 6.64239 12.75 5.25C12.75 3.85761 12.1969 2.52226 11.2123 1.53769C10.2277 0.553123 8.89239 4.996e-16 7.5 0C6.10761 6.66134e-16 4.77226 0.553123 3.78769 1.53769C2.80312 2.52226 2.25 3.85761 2.25 5.25C2.25 6.64239 2.80312 7.97774 3.78769 8.96231C4.77226 9.94688 6.10761 10.5 7.5 10.5ZM7.5 1.5C8.49456 1.5 9.44839 1.89509 10.1517 2.59835C10.8549 3.30161 11.25 4.25544 11.25 5.25C11.25 6.24456 10.8549 7.19839 10.1517 7.90165C9.44839 8.60491 8.49456 9 7.5 9C6.50544 9 5.55161 8.60491 4.84835 7.90165C4.14509 7.19839 3.75 6.24456 3.75 5.25C3.75 4.25544 4.14509 3.30161 4.84835 2.59835C5.55161 1.89509 6.50544 1.5 7.5 1.5Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "SalesReport" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.0625 1.01786L2.0625 16.9643L20.9688 16.9643C21.2423 16.9643 21.5046 17.0715 21.698 17.2624C21.8913 17.4533 22 17.7122 22 17.9821C22 18.2521 21.8913 18.511 21.698 18.7019C21.5046 18.8928 21.2423 19 20.9688 19L1.03125 19C0.757746 19 0.495443 18.8928 0.302046 18.7019C0.108649 18.511 2.28983e-16 18.2521 7.63278e-17 17.9821L0 1.01786C8.58688e-17 0.747905 0.108649 0.489009 0.302046 0.298123C0.495443 0.107238 0.757746 1.50673e-16 1.03125 0C1.30475 1.50673e-16 1.56706 0.107238 1.76045 0.298123C1.95385 0.489009 2.0625 0.747905 2.0625 1.01786ZM21.6975 4.45143L14.4787 11.5764C14.2854 11.767 14.0233 11.8741 13.75 11.8741C13.4767 11.8741 13.2146 11.767 13.0213 11.5764L9.625 8.22429L5.885 11.9157C5.68939 12.0954 5.43082 12.1933 5.16363 12.1887C4.89645 12.1842 4.64145 12.0775 4.45225 11.8913C4.26354 11.7045 4.15553 11.4529 4.15091 11.1891C4.1463 10.9254 4.24544 10.6702 4.4275 10.4771L8.89625 6.06643C9.08961 5.87582 9.35172 5.76875 9.625 5.76875C9.89828 5.76875 10.1604 5.87582 10.3538 6.06643L13.75 9.41857L20.24 3.01286C20.4356 2.83316 20.6942 2.7353 20.9614 2.73986C21.2286 2.74442 21.4835 2.85103 21.6728 3.03729C21.8615 3.22403 21.9695 3.47571 21.9741 3.73943C21.9787 4.00315 21.8796 4.25836 21.6975 4.45143Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "Forecasts" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15L9 15L9 13L11 13L11 15ZM11 11L9 11L9 5L11 5L11 11Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "alert" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9 5L11 5L11 7L9 7L9 5ZM9 9L11 9L11 15L9 15L9 9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "info" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 2L18 2L18 14L3.17 14L2 15.17L2 2ZM2 0C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16L18 16C19.1 16 20 15.1 20 14L20 2C20 0.9 19.1 0 18 0L2 0ZM4 10L12 10L12 12L4 12L4 10ZM4 7L16 7L16 9L4 9L4 7ZM4 4L16 4L16 6L4 6L4 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "chat" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(14.21%, 23.29%)" },
            },
          ],
        },
      },
      variantValues: { type: "checkmark" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14.5 0C12.76 0 11.09 0.81 10 2.09C8.91 0.81 7.24 0 5.5 0C2.42 0 0 2.42 0 5.5C0 9.28 3.4 12.36 8.55 17.04L10 18.35L11.45 17.03C16.6 12.36 20 9.28 20 5.5C20 2.42 17.58 0 14.5 0ZM10.1 15.55L10 15.65L9.9 15.55C5.14 11.24 2 8.39 2 5.5C2 3.5 3.5 2 5.5 2C7.04 2 8.54 2.99 9.07 4.36L10.94 4.36C11.46 2.99 12.96 2 14.5 2C16.5 2 18 3.5 18 5.5C18 8.39 14.86 11.24 10.1 15.55Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 14.58%)" },
            },
          ],
        },
      },
      variantValues: { type: "favorite_border" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(41.67%, 18.75%)" },
            },
          ],
        },
      },
      variantValues: { type: "more_vert" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M12 0L2 0C0.9 0 0 0.9 0 2L0 18L7 15L14 18L14 2C14 0.9 13.1 0 12 0ZM12 15L7 12.82L2 15L2 2L12 2L12 15Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "bookmark_border" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08ZM15 2C15.55 2 16 2.45 16 3C16 3.55 15.55 4 15 4C14.45 4 14 3.55 14 3C14 2.45 14.45 2 15 2ZM3 11C2.45 11 2 10.55 2 10C2 9.45 2.45 9 3 9C3.55 9 4 9.45 4 10C4 10.55 3.55 11 3 11ZM15 18.02C14.45 18.02 14 17.57 14 17.02C14 16.47 14.45 16.02 15 16.02C15.55 16.02 16 16.47 16 17.02C16 17.57 15.55 18.02 15 18.02Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "share" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M8 0L6.59 1.41L12.17 7L0 7L0 9L12.17 9L6.59 14.59L8 16L16 8L8 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 16.67%)" },
            },
          ],
        },
      },
      variantValues: { type: "arrow-right" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7 4L7 0L0 7L7 14L7 9.9C12 9.9 15.5 11.5 18 15C17 10 14 5 7 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 20.83%)" },
            },
          ],
        },
      },
      variantValues: { type: "reply" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M18 0L2 0C0.9 0 0 0.9 0 2L0 20L4 16L18 16C19.1 16 20 15.1 20 14L20 2C20 0.9 19.1 0 18 0ZM18 14L4 14L2 16L2 2L18 2L18 14Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "chat-bubble-outline" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.01 3.03L9.52 6.25L2 5.25L2.01 3.03L2.01 3.03ZM9.51 11.75L2 14.97L2 12.75L9.51 11.75L9.51 11.75ZM0.00999999 0L0 7L15 9L0 11L0.00999999 18L21 9L0.00999999 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "send" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5C0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "favorite" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M6.59 5.17L1.41 0L0 1.41L5.17 6.58L6.59 5.17ZM10.5 0L12.54 2.04L0 14.59L1.41 16L13.96 3.46L16 5.5L16 0L10.5 0ZM10.83 9.41L9.42 10.82L12.55 13.95L10.5 16L16 16L16 10.5L13.96 12.54L10.83 9.41L10.83 9.41Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 16.67%)" },
            },
          ],
        },
      },
      variantValues: { type: "shuffle" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 41.67%)" },
            },
          ],
        },
      },
      variantValues: { type: "more_horiz" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7 8.75C4.66 8.75 0 9.92 0 12.25L0 14L14 14L14 12.25C14 9.92 9.34 8.75 7 8.75ZM2.34 12C3.18 11.42 5.21 10.75 7 10.75C8.79 10.75 10.82 11.42 11.66 12L2.34 12ZM7 7C8.93 7 10.5 5.43 10.5 3.5C10.5 1.57 8.93 0 7 0C5.07 0 3.5 1.57 3.5 3.5C3.5 5.43 5.07 7 7 7ZM7 2C7.83 2 8.5 2.67 8.5 3.5C8.5 4.33 7.83 5 7 5C6.17 5 5.5 4.33 5.5 3.5C5.5 2.67 6.17 2 7 2ZM14.04 8.81C15.2 9.65 16 10.77 16 12.25L16 14L20 14L20 12.25C20 10.23 16.5 9.08 14.04 8.81L14.04 8.81ZM13 7C14.93 7 16.5 5.43 16.5 3.5C16.5 1.57 14.93 0 13 0C12.46 0 11.96 0.13 11.5 0.35C12.13 1.24 12.5 2.33 12.5 3.5C12.5 4.67 12.13 5.76 11.5 6.65C11.96 6.87 12.46 7 13 7Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(8.33%, 20.83%)" },
            },
          ],
        },
      },
      variantValues: { type: "group" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 20.83%)" },
            },
          ],
        },
      },
      variantValues: { type: "close" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M14 4L12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4L2 4C0.9 4 0 4.9 0 6L0 18C0 19.1 0.9 20 2 20L14 20C15.1 20 16 19.1 16 18L16 6C16 4.9 15.1 4 14 4ZM8 2C9.1 2 10 2.9 10 4L6 4C6 2.9 6.9 2 8 2ZM14 18L2 18L2 6L4 6L4 8C4 8.55 4.45 9 5 9C5.55 9 6 8.55 6 8L6 6L10 6L10 8C10 8.55 10.45 9 11 9C11.55 9 12 8.55 12 8L12 6L14 6L14 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(16.67%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "shopping_bag" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11 6L11 16L3 16L3 6L11 6ZM9.5 0L4.5 0L3.5 1L0 1L0 3L14 3L14 1L10.5 1L9.5 0ZM13 4L1 4L1 16C1 17.1 1.9 18 3 18L11 18C12.1 18 13 17.1 13 16L13 4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.83%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "delete" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M0 14.2524L0 18.0024L3.75 18.0024L14.81 6.94244L11.06 3.19244L0 14.2524ZM17.71 2.63244L15.37 0.292444C15.2775 0.19974 15.1676 0.126193 15.0466 0.0760114C14.9257 0.02583 14.796 4.44089e-16 14.665 0C14.534 0 14.4043 0.02583 14.2834 0.0760114C14.1624 0.126193 14.0525 0.19974 13.96 0.292444L12.13 2.12244L15.88 5.87244L17.71 4.04244C17.8027 3.94993 17.8762 3.84004 17.9264 3.71907C17.9766 3.59809 18.0024 3.46841 18.0024 3.33744C18.0024 3.20648 17.9766 3.07679 17.9264 2.95582C17.8762 2.83485 17.8027 2.72496 17.71 2.63244L17.71 2.63244Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 12.49%)" },
            },
          ],
        },
      },
      variantValues: { type: "edit" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M21.1357 6.71786C20.5835 5.41089 19.783 4.22348 18.7786 3.22143C17.7765 2.21696 16.5891 1.41646 15.2821 0.864286C13.9243 0.289732 12.4855 0 11 0C9.51451 0 8.07567 0.289732 6.71786 0.864286C5.41089 1.41646 4.22348 2.21696 3.22143 3.22143C2.21696 4.22348 1.41646 5.41089 0.864286 6.71786C0.289732 8.07567 0 9.51451 0 11C0 14.2583 1.43147 17.3275 3.92612 19.4243L3.96786 19.4587C4.11027 19.5766 4.28951 19.6429 4.47366 19.6429L17.5288 19.6429C17.7129 19.6429 17.8922 19.5766 18.0346 19.4587L18.0763 19.4243C20.5685 17.3275 22 14.2583 22 11C22 9.51451 21.7078 8.07567 21.1357 6.71786ZM17.1237 17.7768L4.87634 17.7768C3.92758 16.9213 3.1693 15.8759 2.6507 14.7084C2.1321 13.541 1.86477 12.2775 1.86607 11C1.86607 8.55937 2.81629 6.26607 4.54241 4.54241C6.26853 2.81629 8.56183 1.86607 11 1.86607C13.4406 1.86607 15.7339 2.81629 17.4576 4.54241C19.1837 6.26853 20.1339 8.56183 20.1339 11C20.1339 13.5929 19.0413 16.0458 17.1237 17.7768ZM13.7377 7.59933C13.7008 7.56277 13.6509 7.54227 13.599 7.54227C13.547 7.54227 13.4972 7.56277 13.4603 7.59933L11.3855 9.67411C10.9263 9.55134 10.4181 9.6692 10.0571 10.0301C9.9293 10.1577 9.82788 10.3093 9.75868 10.4761C9.68948 10.643 9.65386 10.8218 9.65386 11.0025C9.65386 11.1831 9.68948 11.3619 9.75868 11.5288C9.82788 11.6956 9.9293 11.8472 10.0571 11.9748C10.1847 12.1026 10.3363 12.204 10.5031 12.2732C10.67 12.3424 10.8488 12.3781 11.0295 12.3781C11.2101 12.3781 11.3889 12.3424 11.5558 12.2732C11.7226 12.204 11.8742 12.1026 12.0018 11.9748C12.1728 11.8043 12.2958 11.5917 12.3583 11.3584C12.4208 11.1252 12.4206 10.8796 12.3578 10.6464L14.4326 8.57165C14.5087 8.49554 14.5087 8.37031 14.4326 8.2942L13.7377 7.59933ZM10.4598 5.10714L11.5402 5.10714C11.6482 5.10714 11.7366 5.01875 11.7366 4.91071L11.7366 2.94643C11.7366 2.83839 11.6482 2.75 11.5402 2.75L10.4598 2.75C10.3518 2.75 10.2634 2.83839 10.2634 2.94643L10.2634 4.91071C10.2634 5.01875 10.3518 5.10714 10.4598 5.10714ZM16.8438 10.4598L16.8438 11.5402C16.8438 11.6482 16.9321 11.7366 17.0402 11.7366L19.0045 11.7366C19.1125 11.7366 19.2009 11.6482 19.2009 11.5402L19.2009 10.4598C19.2009 10.3518 19.1125 10.2634 19.0045 10.2634L17.0402 10.2634C16.9321 10.2634 16.8438 10.3518 16.8438 10.4598ZM17.1556 5.61786L16.392 4.85424C16.355 4.81769 16.3052 4.79718 16.2532 4.79718C16.2013 4.79718 16.1514 4.81769 16.1145 4.85424L14.7248 6.24397C14.6882 6.28089 14.6677 6.33075 14.6677 6.3827C14.6677 6.43466 14.6882 6.48451 14.7248 6.52143L15.4884 7.28504C15.5645 7.36116 15.6897 7.36116 15.7658 7.28504L17.1556 5.89531C17.2317 5.8192 17.2317 5.69397 17.1556 5.61786ZM5.89531 4.85424C5.85839 4.81769 5.80854 4.79718 5.75659 4.79718C5.70463 4.79718 5.65478 4.81769 5.61786 4.85424L4.85424 5.61786C4.81769 5.65478 4.79718 5.70463 4.79718 5.75659C4.79718 5.80854 4.81769 5.85839 4.85424 5.89531L6.24397 7.28504C6.32009 7.36116 6.44531 7.36116 6.52143 7.28504L7.28504 6.52143C7.36116 6.44531 7.36116 6.32009 7.28504 6.24397L5.89531 4.85424ZM4.86161 10.2634L2.89732 10.2634C2.78929 10.2634 2.70089 10.3518 2.70089 10.4598L2.70089 11.5402C2.70089 11.6482 2.78929 11.7366 2.89732 11.7366L4.86161 11.7366C4.96964 11.7366 5.05804 11.6482 5.05804 11.5402L5.05804 10.4598C5.05804 10.3518 4.96964 10.2634 4.86161 10.2634Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 9.82px - 0.18px))",
              },
            },
          ],
        },
      },
      variantValues: { type: "dashboard" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M3.93138 0L2.35883 0L2.35883 7.86276L3.93138 7.86276L3.93138 0ZM13.5239 7.86276L8.49178 7.86276L7.86276 6.99785L7.86276 5.4253L8.49178 4.71766L13.5239 4.71766L14.153 5.50393L14.153 7.07648L13.5239 7.86276ZM5.66119 12.5804L0.629021 12.5804L0 11.7941L0 10.2216L0.629021 9.43531L5.66119 9.43531L6.29021 10.2216L6.29021 11.7941L5.66119 12.5804ZM11.7941 0L10.2216 0L10.2216 3.1451L11.7941 3.1451L11.7941 0ZM10.2216 9.43531L11.7941 9.43531L11.7941 18.8706L10.2216 18.8706L10.2216 9.43531ZM3.93138 14.153L2.35883 14.153L2.35883 18.8706L3.93138 18.8706L3.93138 14.153ZM16.3545 14.153L21.371 14.153L22 13.3667L22 11.8728L21.371 11.0865L16.3545 11.0865L15.7255 11.8728L15.7255 13.3667L16.3545 14.153ZM19.6569 0L18.0843 0L18.0843 9.43531L19.6569 9.43531L19.6569 0ZM18.0843 15.7255L19.6569 15.7255L19.6569 18.8706L18.0843 18.8706L18.0843 15.7255Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "evenodd",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 9.44px - -0.44px))",
              },
            },
          ],
        },
      },
      variantValues: { type: "settings" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9.02564 22C10.2667 22 11.2821 20.9846 11.2821 19.7436L6.76923 19.7436C6.76923 20.9846 7.78462 22 9.02564 22ZM15.7949 15.2308L15.7949 9.58974C15.7949 6.12615 13.9559 3.22667 10.7179 2.45949L10.7179 1.69231C10.7179 0.755897 9.96205 0 9.02564 0C8.08923 0 7.33333 0.755897 7.33333 1.69231L7.33333 2.45949C4.10667 3.22667 2.25641 6.11487 2.25641 9.58974L2.25641 15.2308L0 17.4872L0 18.6154L18.0513 18.6154L18.0513 17.4872L15.7949 15.2308ZM13.5385 16.359L4.51282 16.359L4.51282 9.58974C4.51282 6.7918 6.21641 4.51282 9.02564 4.51282C11.8349 4.51282 13.5385 6.7918 13.5385 9.58974L13.5385 16.359Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 9.03px - -0.03px), calc(50% - 11px - 0px))",
              },
            },
          ],
        },
      },
      variantValues: { type: "notification" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M19.7386 4.45304C19.7526 4.64846 19.7526 4.84393 19.7526 5.03935C19.7526 11 15.2158 17.8681 6.92388 17.8681C4.36929 17.8681 1.99621 17.1282 0 15.844C0.362958 15.8858 0.711909 15.8998 1.08883 15.8998C3.19667 15.8998 5.13706 15.1879 6.68656 13.9734C4.70432 13.9315 3.04314 12.6333 2.4708 10.8465C2.75001 10.8883 3.02918 10.9163 3.32236 10.9163C3.72717 10.9163 4.13202 10.8604 4.5089 10.7627C2.44291 10.3439 0.893367 8.5292 0.893367 6.33757L0.893367 6.28175C1.4936 6.61678 2.19163 6.82617 2.93143 6.85406C1.71695 6.04439 0.921297 4.66243 0.921297 3.09896C0.921297 2.26141 1.14461 1.49364 1.53549 0.823585C3.75505 3.55963 7.09138 5.34641 10.8325 5.54187C10.7627 5.20684 10.7208 4.85789 10.7208 4.5089C10.7208 2.02409 12.731 0 15.2297 0C16.5279 0 17.7005 0.544416 18.5241 1.42386C19.5431 1.22844 20.5203 0.851515 21.3858 0.335029C21.0507 1.38201 20.3388 2.26145 19.4036 2.81979C20.3109 2.72212 21.1904 2.4708 22 2.12185C21.3859 3.01521 20.6181 3.81087 19.7386 4.45304Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 4.7%)" },
            },
          ],
        },
      },
      variantValues: { type: "twitter" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11.0025 5.35828C7.88098 5.35828 5.36319 7.87607 5.36319 10.9975C5.36319 14.119 7.88098 16.6368 11.0025 16.6368C14.1239 16.6368 16.6417 14.119 16.6417 10.9975C16.6417 7.87607 14.1239 5.35828 11.0025 5.35828ZM11.0025 14.6638C8.98528 14.6638 7.3362 13.0196 7.3362 10.9975C7.3362 8.97546 8.98037 7.33129 11.0025 7.33129C13.0245 7.33129 14.6687 8.97546 14.6687 10.9975C14.6687 13.0196 13.0196 14.6638 11.0025 14.6638ZM18.1877 5.12761C18.1877 5.8589 17.5988 6.44295 16.8724 6.44295C16.1411 6.44295 15.5571 5.85399 15.5571 5.12761C15.5571 4.40123 16.146 3.81227 16.8724 3.81227C17.5988 3.81227 18.1877 4.40123 18.1877 5.12761ZM21.9227 6.46258C21.8393 4.70061 21.4368 3.13988 20.146 1.85399C18.8601 0.568098 17.2994 0.165644 15.5374 0.0773006C13.7215 -0.0257669 8.27853 -0.0257669 6.46258 0.0773006C4.70552 0.160736 3.14479 0.56319 1.85399 1.84908C0.56319 3.13497 0.165644 4.69571 0.0773006 6.45767C-0.0257669 8.27362 -0.0257669 13.7166 0.0773006 15.5325C0.160736 17.2945 0.56319 18.8552 1.85399 20.1411C3.14479 21.427 4.70061 21.8294 6.46258 21.9178C8.27853 22.0209 13.7215 22.0209 15.5374 21.9178C17.2994 21.8344 18.8601 21.4319 20.146 20.1411C21.4319 18.8552 21.8344 17.2945 21.9227 15.5325C22.0258 13.7166 22.0258 8.27853 21.9227 6.46258ZM19.5767 17.481C19.1939 18.4429 18.4528 19.184 17.4859 19.5718C16.038 20.146 12.6025 20.0135 11.0025 20.0135C9.40245 20.0135 5.96196 20.1411 4.51902 19.5718C3.55705 19.189 2.81595 18.4479 2.42822 17.481C1.85399 16.0331 1.9865 12.5975 1.9865 10.9975C1.9865 9.39755 1.8589 5.95706 2.42822 4.51411C2.81104 3.55215 3.55215 2.81104 4.51902 2.42331C5.96687 1.84908 9.40245 1.98159 11.0025 1.98159C12.6025 1.98159 16.0429 1.85399 17.4859 2.42331C18.4479 2.80613 19.189 3.54724 19.5767 4.51411C20.1509 5.96196 20.0184 9.39755 20.0184 10.9975C20.0184 12.5975 20.1509 16.038 19.5767 17.481Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.12%, 3.11%)" },
            },
          ],
        },
      },
      variantValues: { type: "instagram" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M22 2.2C22 0.99 21.01 0 19.8 0L2.2 0C0.99 0 0 0.99 0 2.2L0 15.4C0 16.61 0.99 17.6 2.2 17.6L19.8 17.6C21.01 17.6 22 16.61 22 15.4L22 2.2ZM19.8 2.2L11 7.7L2.2 2.2L19.8 2.2ZM19.8 15.4L2.2 15.4L2.2 4.4L11 9.9L19.8 4.4L19.8 15.4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 11px - 0px), calc(50% - 8.8px - 0.2px))",
              },
            },
          ],
        },
      },
      variantValues: { type: "email" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M12 0.00999999L2 0C0.9 0 0 0.9 0 2L0 20C0 21.1 0.9 22 2 22L12 22C13.1 22 14 21.1 14 20L14 2C14 0.9 13.1 0.00999999 12 0.00999999ZM12 18L2 18L2 4L12 4L12 18Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: {
                transform:
                  "translate(calc(50% - 7px - 0px), calc(50% - 11px - 0px))",
              },
            },
          ],
        },
      },
      variantValues: { type: "phone" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M7.7 0C3.443 0 0 3.443 0 7.7C0 13.475 7.7 22 7.7 22C7.7 22 15.4 13.475 15.4 7.7C15.4 3.443 11.957 0 7.7 0ZM2.2 7.7C2.2 4.664 4.664 2.2 7.7 2.2C10.736 2.2 13.2 4.664 13.2 7.7C13.2 10.868 10.032 15.609 7.7 18.568C5.412 15.631 2.2 10.835 2.2 7.7Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M2.75 5.5C4.26878 5.5 5.5 4.26878 5.5 2.75C5.5 1.23122 4.26878 0 2.75 0C1.23122 0 0 1.23122 0 2.75C0 4.26878 1.23122 5.5 2.75 5.5Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(20.62%, 20.62%)" },
            },
          ],
        },
      },
      variantValues: { type: "location" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M16 2L11.82 2C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2L2 2C0.9 2 0 2.9 0 4L0 20C0 21.1 0.9 22 2 22L16 22C17.1 22 18 21.1 18 20L18 4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM16 20L2 20L2 4L4 4L4 7L14 7L14 4L16 4L16 20Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "content" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M11 0L2.2 0C0.99 0 0.0110003 0.99 0.0110003 2.2L0 19.8C0 21.01 0.979 22 2.189 22L15.4 22C16.61 22 17.6 21.01 17.6 19.8L17.6 6.6L11 0ZM2.2 19.8L2.2 2.2L9.9 2.2L9.9 7.7L15.4 7.7L15.4 19.8L2.2 19.8Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "file" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M19.8 2.2L11 2.2L8.8 0L2.2 0C0.99 0 0.011 0.99 0.011 2.2L0 15.4C0 16.61 0.99 17.6 2.2 17.6L19.8 17.6C21.01 17.6 22 16.61 22 15.4L22 4.4C22 3.19 21.01 2.2 19.8 2.2ZM19.8 15.4L2.2 15.4L2.2 4.4L19.8 4.4L19.8 15.4Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 8.33%)" },
            },
          ],
        },
      },
      variantValues: { type: "storage" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M-0.40534 10.7072C-0.567018 10.9311 -0.516608 11.2436 -0.292745 11.4053C-0.0688824 11.567 0.243661 11.5166 0.40534 11.2927L-0.40534 10.7072ZM8.34975 0.292745C8.51143 0.0688824 8.46102 -0.243661 8.23716 -0.40534C8.01329 -0.567018 7.70075 -0.516608 7.53907 -0.292745L8.34975 0.292745ZM0.40534 11.2927L8.34975 0.292745L7.53907 -0.292745L-0.40534 10.7072L0.40534 11.2927Z",
              stroke: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              strokeLinejoin: "round",
              strokeWidth: 1,
              style: { transform: "translate(2.08%, 37.73%)" },
            },
            {
              d: "M14.6666 20.0555C14.9427 20.0555 15.1666 19.8316 15.1666 19.5555C15.1666 19.2793 14.9427 19.0555 14.6666 19.0555L14.6666 20.0555ZM0 -0.5C-0.276142 -0.5 -0.5 -0.276142 -0.5 0C-0.5 0.276142 -0.276142 0.5 0 0.5L0 -0.5ZM14.6666 19.0555C13.0959 19.0555 11.8521 18.0199 10.7365 16.2349C9.62274 14.453 8.72357 12.0611 7.80147 9.60218C6.89025 7.17225 5.95609 4.67525 4.77815 2.79054C3.60209 0.908843 2.09595 -0.5 0 -0.5L0 0.5C1.57071 0.5 2.81455 1.53559 3.93015 3.32054C5.04386 5.10248 5.94303 7.49435 6.86514 9.9533C7.77636 12.3832 8.71052 14.8802 9.88846 16.7649C11.0645 18.6466 12.5707 20.0555 14.6666 20.0555L14.6666 19.0555Z",
              stroke: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              strokeLinejoin: "round",
              strokeWidth: 1,
              style: { transform: "translate(7.18%, 2.08%)" },
            },
          ],
        },
      },
      variantValues: { type: "function" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2 19L2 9L14 9L14 10C14.7 10 15.37 10.1 16 10.29L16 9C16 7.9 15.1 7 14 7L13 7L13 5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5L3 7L2 7C0.9 7 0 7.9 0 9L0 19C0 20.1 0.9 21 2 21L8.26 21C7.84 20.4 7.51 19.72 7.29 19L2 19ZM5 5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5L11 7L5 7L5 5Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 2C5.83 2 6.5 2.67 6.5 3.5C6.5 4.33 5.83 5 5 5C4.17 5 3.5 4.33 3.5 3.5C3.5 2.67 4.17 2 5 2ZM5 8C3.97 8 3.06 7.48 2.52 6.68C3.25 6.26 4.09 6 5 6C5.91 6 6.75 6.26 7.48 6.68C6.94 7.48 6.03 8 5 8Z",
              fill: "rgba(0,0,0,1)",
              fillRule: "nonzero",
              style: { transform: "translate(37.5%, 50%)" },
            },
          ],
        },
      },
      variantValues: { type: "authentication" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M2.31579 11C2.31579 11.3624 2.84958 11.9935 4.08737 12.6129C5.68989 13.4142 7.96284 13.8947 10.4211 13.8947C12.8793 13.8947 15.1522 13.4142 16.7547 12.6129C17.9925 11.9935 18.5263 11.3624 18.5263 11L18.5263 8.48621C16.6158 9.66726 13.6944 10.4211 10.4211 10.4211C7.14768 10.4211 4.22632 9.66611 2.31579 8.48621L2.31579 11ZM18.5263 14.2757C16.6158 15.4567 13.6944 16.2105 10.4211 16.2105C7.14768 16.2105 4.22632 15.4556 2.31579 14.2757L2.31579 16.7895C2.31579 17.1519 2.84958 17.7829 4.08737 18.4024C5.68989 19.2037 7.96284 19.6842 10.4211 19.6842C12.8793 19.6842 15.1522 19.2037 16.7547 18.4024C17.9925 17.7829 18.5263 17.1519 18.5263 16.7895L18.5263 14.2757ZM0 16.7895L0 5.21053C0 2.33316 4.66632 0 10.4211 0C16.1758 0 20.8421 2.33316 20.8421 5.21053L20.8421 16.7895C20.8421 19.6668 16.1758 22 10.4211 22C4.66632 22 0 19.6668 0 16.7895ZM10.4211 8.10526C12.8793 8.10526 15.1522 7.62474 16.7547 6.82347C17.9925 6.204 18.5263 5.57295 18.5263 5.21053C18.5263 4.84811 17.9925 4.21705 16.7547 3.59758C15.1522 2.79632 12.8793 2.31579 10.4211 2.31579C7.96284 2.31579 5.68989 2.79632 4.08737 3.59758C2.84958 4.21705 2.31579 4.84811 2.31579 5.21053C2.31579 5.57295 2.84958 6.204 4.08737 6.82347C5.68989 7.62474 7.96284 8.10526 10.4211 8.10526Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "data" },
    },
    {
      overrides: {
        MyIcon: {
          paths: [
            {
              d: "M9.41407 0.41681C9.73187 0.14769 10.1348 0 10.5513 0C10.9677 -5.20633e-16 11.3707 0.14769 11.6885 0.41681L20.4812 7.87655C20.6759 8.04162 20.8323 8.24708 20.9396 8.47869C21.0469 8.71029 21.1025 8.96248 21.1025 9.21773L21.1025 20.2415C21.1025 20.7079 20.9172 21.1551 20.5875 21.4849C20.2577 21.8147 19.8104 22 19.344 22L12.6029 22C12.3697 22 12.1461 21.9074 11.9812 21.7425C11.8163 21.5776 11.7236 21.3539 11.7236 21.1207L11.7236 13.7935L9.3789 13.7935L9.3789 21.1207C9.3789 21.3539 9.28626 21.5776 9.12137 21.7425C8.95647 21.9074 8.73282 22 8.49963 22L1.75854 22C1.29215 22 0.844856 21.8147 0.515065 21.4849C0.185275 21.1551 0 20.7079 0 20.2415L0 9.21773C0 8.70189 0.227438 8.21068 0.621352 7.87655L9.41407 0.41681ZM10.5513 1.75799L1.75854 9.21773L1.75854 20.2415L7.62036 20.2415L7.62036 12.9142C7.62036 12.681 7.71299 12.4573 7.87789 12.2925C8.04278 12.1276 8.26643 12.0349 8.49963 12.0349L12.6029 12.0349C12.8361 12.0349 13.0597 12.1276 13.2246 12.2925C13.3895 12.4573 13.4822 12.681 13.4822 12.9142L13.4822 20.2415L19.344 20.2415L19.344 9.21773L10.5513 1.75799Z",
              fill: "rgba(92,102,112,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "home" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Icon
      width="24px"
      height="24px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
      paths={[
        {
          d: "M0 19L22 19L11 0L0 19ZM12 16L10 16L10 14L12 14L12 16ZM12 12L10 12L10 8L12 8L12 12Z",
          fill: "rgba(92,102,112,1)",
          fillRule: "nonzero",
          style: { transform: "translate(4.17%, 12.5%)" },
        },
      ]}
      {...getOverrideProps(overrides, "MyIcon")}
      {...rest}
    ></Icon>
  );
}
